var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
/*! For license information please see index.esm.js.LICENSE.txt */
import * as e from "react";
import * as t from "react/jsx-runtime";
import * as r from "@shared-ui/localization-context";
import * as n from "throttle-debounce";
import * as o from "uitk-react-utils";
import * as i from "uitk-react-spacing";
import * as a from "uitk-react-button";
var s = {
    458: e => {
      var t = Object.getOwnPropertySymbols,
        r = Object.prototype.hasOwnProperty,
        n = Object.prototype.propertyIsEnumerable;
      e.exports = function () {
        try {
          if (!Object.assign) return !1;
          var e = new String("abc");
          if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;
          for (var t = {}, r = 0; r < 10; r++) t["_" + String.fromCharCode(r)] = r;
          if ("0123456789" !== Object.getOwnPropertyNames(t).map(function (e) {
            return t[e];
          }).join("")) return !1;
          var n = {};
          return "abcdefghijklmnopqrst".split("").forEach(function (e) {
            n[e] = e;
          }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, n)).join("");
        } catch (e) {
          return !1;
        }
      }() ? Object.assign : function (e, o) {
        for (var i, a, s = function (e) {
            if (null == e) throw new TypeError("Object.assign cannot be called with null or undefined");
            return Object(e);
          }(e), l = 1; l < arguments.length; l++) {
          for (var u in i = Object(arguments[l])) r.call(i, u) && (s[u] = i[u]);
          if (t) {
            a = t(i);
            for (var c = 0; c < a.length; c++) n.call(i, a[c]) && (s[a[c]] = i[a[c]]);
          }
        }
        return s;
      };
    },
    634: (e, t, r) => {
      var n = r(458),
        o = r(810);
      function i(e) {
        for (var t = "https://reactjs.org/docs/error-decoder.html?invariant=" + e, r = 1; r < arguments.length; r++) t += "&args[]=" + encodeURIComponent(arguments[r]);
        return "Minified React error #" + e + "; visit " + t + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
      }
      var a = 60106,
        s = 60107,
        l = 60108,
        u = 60114,
        c = 60109,
        d = 60110,
        f = 60112,
        h = 60113,
        p = 60120,
        m = 60115,
        g = 60116,
        v = 60121,
        y = 60117,
        x = 60119,
        w = 60129,
        b = 60131;
      if ("function" == typeof Symbol && Symbol.for) {
        var S = Symbol.for;
        a = S("react.portal"), s = S("react.fragment"), l = S("react.strict_mode"), u = S("react.profiler"), c = S("react.provider"), d = S("react.context"), f = S("react.forward_ref"), h = S("react.suspense"), p = S("react.suspense_list"), m = S("react.memo"), g = S("react.lazy"), v = S("react.block"), y = S("react.fundamental"), x = S("react.scope"), w = S("react.debug_trace_mode"), b = S("react.legacy_hidden");
      }
      function k(e) {
        if (null == e) return null;
        if ("function" == typeof e) return e.displayName || e.name || null;
        if ("string" == typeof e) return e;
        switch (e) {
          case s:
            return "Fragment";
          case a:
            return "Portal";
          case u:
            return "Profiler";
          case l:
            return "StrictMode";
          case h:
            return "Suspense";
          case p:
            return "SuspenseList";
        }
        if ("object" == typeof e) switch (e.$$typeof) {
          case d:
            return (e.displayName || "Context") + ".Consumer";
          case c:
            return (e._context.displayName || "Context") + ".Provider";
          case f:
            var t = e.render;
            return t = t.displayName || t.name || "", e.displayName || ("" !== t ? "ForwardRef(" + t + ")" : "ForwardRef");
          case m:
            return k(e.type);
          case v:
            return k(e._render);
          case g:
            t = e._payload, e = e._init;
            try {
              return k(e(t));
            } catch (e) {}
        }
        return null;
      }
      var I = o.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,
        E = {};
      function C(e, t) {
        for (var r = 0 | e._threadCount; r <= t; r++) e[r] = e._currentValue2, e._threadCount = r + 1;
      }
      for (var N = new Uint16Array(16), L = 0; 15 > L; L++) N[L] = L + 1;
      N[15] = 0;
      var O = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,
        T = Object.prototype.hasOwnProperty,
        R = {},
        F = {};
      function A(e) {
        return !!T.call(F, e) || !T.call(R, e) && (O.test(e) ? F[e] = !0 : (R[e] = !0, !1));
      }
      function P(e, t, r, n, o, i, a) {
        this.acceptsBooleans = 2 === t || 3 === t || 4 === t, this.attributeName = n, this.attributeNamespace = o, this.mustUseProperty = r, this.propertyName = e, this.type = t, this.sanitizeURL = i, this.removeEmptyString = a;
      }
      var D = {};
      "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function (e) {
        D[e] = new P(e, 0, !1, e, null, !1, !1);
      }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function (e) {
        var t = e[0];
        D[t] = new P(t, 1, !1, e[1], null, !1, !1);
      }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function (e) {
        D[e] = new P(e, 2, !1, e.toLowerCase(), null, !1, !1);
      }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function (e) {
        D[e] = new P(e, 2, !1, e, null, !1, !1);
      }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function (e) {
        D[e] = new P(e, 3, !1, e.toLowerCase(), null, !1, !1);
      }), ["checked", "multiple", "muted", "selected"].forEach(function (e) {
        D[e] = new P(e, 3, !0, e, null, !1, !1);
      }), ["capture", "download"].forEach(function (e) {
        D[e] = new P(e, 4, !1, e, null, !1, !1);
      }), ["cols", "rows", "size", "span"].forEach(function (e) {
        D[e] = new P(e, 6, !1, e, null, !1, !1);
      }), ["rowSpan", "start"].forEach(function (e) {
        D[e] = new P(e, 5, !1, e.toLowerCase(), null, !1, !1);
      });
      var j = /[\-:]([a-z])/g;
      function V(e) {
        return e[1].toUpperCase();
      }
      "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function (e) {
        var t = e.replace(j, V);
        D[t] = new P(t, 1, !1, e, null, !1, !1);
      }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function (e) {
        var t = e.replace(j, V);
        D[t] = new P(t, 1, !1, e, "http://www.w3.org/1999/xlink", !1, !1);
      }), ["xml:base", "xml:lang", "xml:space"].forEach(function (e) {
        var t = e.replace(j, V);
        D[t] = new P(t, 1, !1, e, "http://www.w3.org/XML/1998/namespace", !1, !1);
      }), ["tabIndex", "crossOrigin"].forEach(function (e) {
        D[e] = new P(e, 1, !1, e.toLowerCase(), null, !1, !1);
      }), D.xlinkHref = new P("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1), ["src", "href", "action", "formAction"].forEach(function (e) {
        D[e] = new P(e, 1, !1, e.toLowerCase(), null, !0, !0);
      });
      var M = /["'&<>]/;
      function z(e) {
        if ("boolean" == typeof e || "number" == typeof e) return "" + e;
        e = "" + e;
        var t = M.exec(e);
        if (t) {
          var r,
            n = "",
            o = 0;
          for (r = t.index; r < e.length; r++) {
            switch (e.charCodeAt(r)) {
              case 34:
                t = "&quot;";
                break;
              case 38:
                t = "&amp;";
                break;
              case 39:
                t = "&#x27;";
                break;
              case 60:
                t = "&lt;";
                break;
              case 62:
                t = "&gt;";
                break;
              default:
                continue;
            }
            o !== r && (n += e.substring(o, r)), o = r + 1, n += t;
          }
          e = o !== r ? n + e.substring(o, r) : n;
        }
        return e;
      }
      function _(e, t) {
        var r,
          n = D.hasOwnProperty(e) ? D[e] : null;
        return (r = "style" !== e) && (r = null !== n ? 0 === n.type : 2 < e.length && ("o" === e[0] || "O" === e[0]) && ("n" === e[1] || "N" === e[1])), r || function (e, t, r, n) {
          if (null == t || function (e, t, r, n) {
            if (null !== r && 0 === r.type) return !1;
            switch (typeof t) {
              case "function":
              case "symbol":
                return !0;
              case "boolean":
                return null !== r ? !r.acceptsBooleans : "data-" !== (e = e.toLowerCase().slice(0, 5)) && "aria-" !== e;
              default:
                return !1;
            }
          }(e, t, r)) return !0;
          if (null !== r) switch (r.type) {
            case 3:
              return !t;
            case 4:
              return !1 === t;
            case 5:
              return isNaN(t);
            case 6:
              return isNaN(t) || 1 > t;
          }
          return !1;
        }(e, t, n) ? "" : null !== n ? (e = n.attributeName, 3 === (r = n.type) || 4 === r && !0 === t ? e + '=""' : (n.sanitizeURL && (t = "" + t), e + '="' + z(t) + '"')) : A(e) ? e + '="' + z(t) + '"' : "";
      }
      var W = "function" == typeof Object.is ? Object.is : function (e, t) {
          return e === t && (0 !== e || 1 / e == 1 / t) || e != e && t != t;
        },
        $ = null,
        H = null,
        q = null,
        B = !1,
        U = !1,
        G = null,
        Z = 0;
      function K() {
        if (null === $) throw Error(i(321));
        return $;
      }
      function Y() {
        if (0 < Z) throw Error(i(312));
        return {
          memoizedState: null,
          queue: null,
          next: null
        };
      }
      function J() {
        return null === q ? null === H ? (B = !1, H = q = Y()) : (B = !0, q = H) : null === q.next ? (B = !1, q = q.next = Y()) : (B = !0, q = q.next), q;
      }
      function X(e, t, r, n) {
        for (; U;) U = !1, Z += 1, q = null, r = e(t, n);
        return Q(), r;
      }
      function Q() {
        $ = null, U = !1, H = null, Z = 0, q = G = null;
      }
      function ee(e, t) {
        return "function" == typeof t ? t(e) : t;
      }
      function te(e, t, r) {
        if ($ = K(), q = J(), B) {
          var n = q.queue;
          if (t = n.dispatch, null !== G && void 0 !== (r = G.get(n))) {
            G.delete(n), n = q.memoizedState;
            do {
              n = e(n, r.action), r = r.next;
            } while (null !== r);
            return q.memoizedState = n, [n, t];
          }
          return [q.memoizedState, t];
        }
        return e = e === ee ? "function" == typeof t ? t() : t : void 0 !== r ? r(t) : t, q.memoizedState = e, e = (e = q.queue = {
          last: null,
          dispatch: null
        }).dispatch = ne.bind(null, $, e), [q.memoizedState, e];
      }
      function re(e, t) {
        if ($ = K(), t = void 0 === t ? null : t, null !== (q = J())) {
          var r = q.memoizedState;
          if (null !== r && null !== t) {
            var n = r[1];
            e: if (null === n) n = !1;else {
              for (var o = 0; o < n.length && o < t.length; o++) if (!W(t[o], n[o])) {
                n = !1;
                break e;
              }
              n = !0;
            }
            if (n) return r[0];
          }
        }
        return e = e(), q.memoizedState = [e, t], e;
      }
      function ne(e, t, r) {
        if (!(25 > Z)) throw Error(i(301));
        if (e === $) if (U = !0, e = {
          action: r,
          next: null
        }, null === G && (G = new Map()), void 0 === (r = G.get(t))) G.set(t, e);else {
          for (t = r; null !== t.next;) t = t.next;
          t.next = e;
        }
      }
      function oe() {}
      var ie = null,
        ae = {
          readContext: function (e) {
            var t = ie.threadID;
            return C(e, t), e[t];
          },
          useContext: function (e) {
            K();
            var t = ie.threadID;
            return C(e, t), e[t];
          },
          useMemo: re,
          useReducer: te,
          useRef: function (e) {
            $ = K();
            var t = (q = J()).memoizedState;
            return null === t ? (e = {
              current: e
            }, q.memoizedState = e) : t;
          },
          useState: function (e) {
            return te(ee, e);
          },
          useLayoutEffect: function () {},
          useCallback: function (e, t) {
            return re(function () {
              return e;
            }, t);
          },
          useImperativeHandle: oe,
          useEffect: oe,
          useDebugValue: oe,
          useDeferredValue: function (e) {
            return K(), e;
          },
          useTransition: function () {
            return K(), [function (e) {
              e();
            }, !1];
          },
          useOpaqueIdentifier: function () {
            return (ie.identifierPrefix || "") + "R:" + (ie.uniqueID++).toString(36);
          },
          useMutableSource: function (e, t) {
            return K(), t(e._source);
          }
        },
        se = "http://www.w3.org/1999/xhtml";
      function le(e) {
        switch (e) {
          case "svg":
            return "http://www.w3.org/2000/svg";
          case "math":
            return "http://www.w3.org/1998/Math/MathML";
          default:
            return "http://www.w3.org/1999/xhtml";
        }
      }
      var ue = {
          area: !0,
          base: !0,
          br: !0,
          col: !0,
          embed: !0,
          hr: !0,
          img: !0,
          input: !0,
          keygen: !0,
          link: !0,
          meta: !0,
          param: !0,
          source: !0,
          track: !0,
          wbr: !0
        },
        ce = n({
          menuitem: !0
        }, ue),
        de = {
          animationIterationCount: !0,
          borderImageOutset: !0,
          borderImageSlice: !0,
          borderImageWidth: !0,
          boxFlex: !0,
          boxFlexGroup: !0,
          boxOrdinalGroup: !0,
          columnCount: !0,
          columns: !0,
          flex: !0,
          flexGrow: !0,
          flexPositive: !0,
          flexShrink: !0,
          flexNegative: !0,
          flexOrder: !0,
          gridArea: !0,
          gridRow: !0,
          gridRowEnd: !0,
          gridRowSpan: !0,
          gridRowStart: !0,
          gridColumn: !0,
          gridColumnEnd: !0,
          gridColumnSpan: !0,
          gridColumnStart: !0,
          fontWeight: !0,
          lineClamp: !0,
          lineHeight: !0,
          opacity: !0,
          order: !0,
          orphans: !0,
          tabSize: !0,
          widows: !0,
          zIndex: !0,
          zoom: !0,
          fillOpacity: !0,
          floodOpacity: !0,
          stopOpacity: !0,
          strokeDasharray: !0,
          strokeDashoffset: !0,
          strokeMiterlimit: !0,
          strokeOpacity: !0,
          strokeWidth: !0
        },
        fe = ["Webkit", "ms", "Moz", "O"];
      Object.keys(de).forEach(function (e) {
        fe.forEach(function (t) {
          t = t + e.charAt(0).toUpperCase() + e.substring(1), de[t] = de[e];
        });
      });
      var he = /([A-Z])/g,
        pe = /^ms-/,
        me = o.Children.toArray,
        ge = I.ReactCurrentDispatcher,
        ve = {
          listing: !0,
          pre: !0,
          textarea: !0
        },
        ye = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/,
        xe = {},
        we = {},
        be = Object.prototype.hasOwnProperty,
        Se = {
          children: null,
          dangerouslySetInnerHTML: null,
          suppressContentEditableWarning: null,
          suppressHydrationWarning: null
        };
      function ke(e, t) {
        if (void 0 === e) throw Error(i(152, k(t) || "Component"));
      }
      var Ie = function () {
        function e(e, t, r) {
          o.isValidElement(e) ? e.type !== s ? e = [e] : (e = e.props.children, e = o.isValidElement(e) ? [e] : me(e)) : e = me(e), e = {
            type: null,
            domNamespace: se,
            children: e,
            childIndex: 0,
            context: E,
            footer: ""
          };
          var n = N[0];
          if (0 === n) {
            var a = N,
              l = 2 * (n = a.length);
            if (!(65536 >= l)) throw Error(i(304));
            var u = new Uint16Array(l);
            for (u.set(a), (N = u)[0] = n + 1, a = n; a < l - 1; a++) N[a] = a + 1;
            N[l - 1] = 0;
          } else N[0] = N[n];
          this.threadID = n, this.stack = [e], this.exhausted = !1, this.currentSelectValue = null, this.previousWasTextNode = !1, this.makeStaticMarkup = t, this.suspenseDepth = 0, this.contextIndex = -1, this.contextStack = [], this.contextValueStack = [], this.uniqueID = 0, this.identifierPrefix = r && r.identifierPrefix || "";
        }
        var t = e.prototype;
        return t.destroy = function () {
          if (!this.exhausted) {
            this.exhausted = !0, this.clearProviders();
            var e = this.threadID;
            N[e] = N[0], N[0] = e;
          }
        }, t.pushProvider = function (e) {
          var t = ++this.contextIndex,
            r = e.type._context,
            n = this.threadID;
          C(r, n);
          var o = r[n];
          this.contextStack[t] = r, this.contextValueStack[t] = o, r[n] = e.props.value;
        }, t.popProvider = function () {
          var e = this.contextIndex,
            t = this.contextStack[e],
            r = this.contextValueStack[e];
          this.contextStack[e] = null, this.contextValueStack[e] = null, this.contextIndex--, t[this.threadID] = r;
        }, t.clearProviders = function () {
          for (var e = this.contextIndex; 0 <= e; e--) this.contextStack[e][this.threadID] = this.contextValueStack[e];
        }, t.read = function (e) {
          if (this.exhausted) return null;
          var t = ie;
          ie = this;
          var r = ge.current;
          ge.current = ae;
          try {
            for (var n = [""], o = !1; n[0].length < e;) {
              if (0 === this.stack.length) {
                this.exhausted = !0;
                var a = this.threadID;
                N[a] = N[0], N[0] = a;
                break;
              }
              var s = this.stack[this.stack.length - 1];
              if (o || s.childIndex >= s.children.length) {
                var l = s.footer;
                if ("" !== l && (this.previousWasTextNode = !1), this.stack.pop(), "select" === s.type) this.currentSelectValue = null;else if (null != s.type && null != s.type.type && s.type.type.$$typeof === c) this.popProvider(s.type);else if (s.type === h) {
                  this.suspenseDepth--;
                  var u = n.pop();
                  if (o) {
                    o = !1;
                    var d = s.fallbackFrame;
                    if (!d) throw Error(i(303));
                    this.stack.push(d), n[this.suspenseDepth] += "\x3c!--$!--\x3e";
                    continue;
                  }
                  n[this.suspenseDepth] += u;
                }
                n[this.suspenseDepth] += l;
              } else {
                var f = s.children[s.childIndex++],
                  p = "";
                try {
                  p += this.render(f, s.context, s.domNamespace);
                } catch (e) {
                  if (null != e && "function" == typeof e.then) throw Error(i(294));
                  throw e;
                }
                n.length <= this.suspenseDepth && n.push(""), n[this.suspenseDepth] += p;
              }
            }
            return n[0];
          } finally {
            ge.current = r, ie = t, Q();
          }
        }, t.render = function (e, t, r) {
          if ("string" == typeof e || "number" == typeof e) return "" == (r = "" + e) ? "" : this.makeStaticMarkup ? z(r) : this.previousWasTextNode ? "\x3c!-- --\x3e" + z(r) : (this.previousWasTextNode = !0, z(r));
          if (e = (t = function (e, t, r) {
            function a(o, a) {
              var s = a.prototype && a.prototype.isReactComponent,
                l = function (e, t, r, n) {
                  if (n && "object" == typeof (n = e.contextType) && null !== n) return C(n, r), n[r];
                  if (e = e.contextTypes) {
                    for (var o in r = {}, e) r[o] = t[o];
                    t = r;
                  } else t = E;
                  return t;
                }(a, t, r, s),
                u = [],
                c = !1,
                d = {
                  isMounted: function () {
                    return !1;
                  },
                  enqueueForceUpdate: function () {
                    if (null === u) return null;
                  },
                  enqueueReplaceState: function (e, t) {
                    c = !0, u = [t];
                  },
                  enqueueSetState: function (e, t) {
                    if (null === u) return null;
                    u.push(t);
                  }
                };
              if (s) {
                if (s = new a(o.props, l, d), "function" == typeof a.getDerivedStateFromProps) {
                  var f = a.getDerivedStateFromProps.call(null, o.props, s.state);
                  null != f && (s.state = n({}, s.state, f));
                }
              } else if ($ = {}, s = a(o.props, l, d), null == (s = X(a, o.props, s, l)) || null == s.render) return void ke(e = s, a);
              if (s.props = o.props, s.context = l, s.updater = d, void 0 === (d = s.state) && (s.state = d = null), "function" == typeof s.UNSAFE_componentWillMount || "function" == typeof s.componentWillMount) if ("function" == typeof s.componentWillMount && "function" != typeof a.getDerivedStateFromProps && s.componentWillMount(), "function" == typeof s.UNSAFE_componentWillMount && "function" != typeof a.getDerivedStateFromProps && s.UNSAFE_componentWillMount(), u.length) {
                d = u;
                var h = c;
                if (u = null, c = !1, h && 1 === d.length) s.state = d[0];else {
                  f = h ? d[0] : s.state;
                  var p = !0;
                  for (h = h ? 1 : 0; h < d.length; h++) {
                    var m = d[h];
                    null != (m = "function" == typeof m ? m.call(s, f, o.props, l) : m) && (p ? (p = !1, f = n({}, f, m)) : n(f, m));
                  }
                  s.state = f;
                }
              } else u = null;
              if (ke(e = s.render(), a), "function" == typeof s.getChildContext && "object" == typeof (o = a.childContextTypes)) {
                var g = s.getChildContext();
                for (var v in g) if (!(v in o)) throw Error(i(108, k(a) || "Unknown", v));
              }
              g && (t = n({}, t, g));
            }
            for (; o.isValidElement(e);) {
              var s = e,
                l = s.type;
              if ("function" != typeof l) break;
              a(s, l);
            }
            return {
              child: e,
              context: t
            };
          }(e, t, this.threadID)).child, t = t.context, null === e || !1 === e) return "";
          if (!o.isValidElement(e)) {
            if (null != e && null != e.$$typeof) {
              if ((r = e.$$typeof) === a) throw Error(i(257));
              throw Error(i(258, r.toString()));
            }
            return e = me(e), this.stack.push({
              type: null,
              domNamespace: r,
              children: e,
              childIndex: 0,
              context: t,
              footer: ""
            }), "";
          }
          var v = e.type;
          if ("string" == typeof v) return this.renderDOM(e, t, r);
          switch (v) {
            case b:
            case w:
            case l:
            case u:
            case p:
            case s:
              return e = me(e.props.children), this.stack.push({
                type: null,
                domNamespace: r,
                children: e,
                childIndex: 0,
                context: t,
                footer: ""
              }), "";
            case h:
              throw Error(i(294));
            case x:
              throw Error(i(343));
          }
          if ("object" == typeof v && null !== v) switch (v.$$typeof) {
            case f:
              $ = {};
              var S = v.render(e.props, e.ref);
              return S = X(v.render, e.props, S, e.ref), S = me(S), this.stack.push({
                type: null,
                domNamespace: r,
                children: S,
                childIndex: 0,
                context: t,
                footer: ""
              }), "";
            case m:
              return e = [o.createElement(v.type, n({
                ref: e.ref
              }, e.props))], this.stack.push({
                type: null,
                domNamespace: r,
                children: e,
                childIndex: 0,
                context: t,
                footer: ""
              }), "";
            case c:
              return r = {
                type: e,
                domNamespace: r,
                children: v = me(e.props.children),
                childIndex: 0,
                context: t,
                footer: ""
              }, this.pushProvider(e), this.stack.push(r), "";
            case d:
              v = e.type, S = e.props;
              var I = this.threadID;
              return C(v, I), v = me(S.children(v[I])), this.stack.push({
                type: e,
                domNamespace: r,
                children: v,
                childIndex: 0,
                context: t,
                footer: ""
              }), "";
            case y:
              throw Error(i(338));
            case g:
              return v = (S = (v = e.type)._init)(v._payload), e = [o.createElement(v, n({
                ref: e.ref
              }, e.props))], this.stack.push({
                type: null,
                domNamespace: r,
                children: e,
                childIndex: 0,
                context: t,
                footer: ""
              }), "";
          }
          throw Error(i(130, null == v ? v : typeof v, ""));
        }, t.renderDOM = function (e, t, r) {
          var a = e.type.toLowerCase();
          if (r === se && le(a), !xe.hasOwnProperty(a)) {
            if (!ye.test(a)) throw Error(i(65, a));
            xe[a] = !0;
          }
          var s = e.props;
          if ("input" === a) s = n({
            type: void 0
          }, s, {
            defaultChecked: void 0,
            defaultValue: void 0,
            value: null != s.value ? s.value : s.defaultValue,
            checked: null != s.checked ? s.checked : s.defaultChecked
          });else if ("textarea" === a) {
            var l = s.value;
            if (null == l) {
              l = s.defaultValue;
              var u = s.children;
              if (null != u) {
                if (null != l) throw Error(i(92));
                if (Array.isArray(u)) {
                  if (!(1 >= u.length)) throw Error(i(93));
                  u = u[0];
                }
                l = "" + u;
              }
              null == l && (l = "");
            }
            s = n({}, s, {
              value: void 0,
              children: "" + l
            });
          } else if ("select" === a) this.currentSelectValue = null != s.value ? s.value : s.defaultValue, s = n({}, s, {
            value: void 0
          });else if ("option" === a) {
            u = this.currentSelectValue;
            var c = function (e) {
              if (null == e) return e;
              var t = "";
              return o.Children.forEach(e, function (e) {
                null != e && (t += e);
              }), t;
            }(s.children);
            if (null != u) {
              var d = null != s.value ? s.value + "" : c;
              if (l = !1, Array.isArray(u)) {
                for (var f = 0; f < u.length; f++) if ("" + u[f] === d) {
                  l = !0;
                  break;
                }
              } else l = "" + u === d;
              s = n({
                selected: void 0,
                children: void 0
              }, s, {
                selected: l,
                children: c
              });
            }
          }
          if (l = s) {
            if (ce[a] && (null != l.children || null != l.dangerouslySetInnerHTML)) throw Error(i(137, a));
            if (null != l.dangerouslySetInnerHTML) {
              if (null != l.children) throw Error(i(60));
              if ("object" != typeof l.dangerouslySetInnerHTML || !("__html" in l.dangerouslySetInnerHTML)) throw Error(i(61));
            }
            if (null != l.style && "object" != typeof l.style) throw Error(i(62));
          }
          l = s, u = this.makeStaticMarkup, c = 1 === this.stack.length, d = "<" + e.type;
          e: if (-1 === a.indexOf("-")) f = "string" == typeof l.is;else switch (a) {
            case "annotation-xml":
            case "color-profile":
            case "font-face":
            case "font-face-src":
            case "font-face-uri":
            case "font-face-format":
            case "font-face-name":
            case "missing-glyph":
              f = !1;
              break e;
            default:
              f = !0;
          }
          for (b in l) if (be.call(l, b)) {
            var h = l[b];
            if (null != h) {
              if ("style" === b) {
                var p = void 0,
                  m = "",
                  g = "";
                for (p in h) if (h.hasOwnProperty(p)) {
                  var v = 0 === p.indexOf("--"),
                    y = h[p];
                  if (null != y) {
                    if (v) var x = p;else if (x = p, we.hasOwnProperty(x)) x = we[x];else {
                      var w = x.replace(he, "-$1").toLowerCase().replace(pe, "-ms-");
                      x = we[x] = w;
                    }
                    m += g + x + ":", g = p, m += v = null == y || "boolean" == typeof y || "" === y ? "" : v || "number" != typeof y || 0 === y || de.hasOwnProperty(g) && de[g] ? ("" + y).trim() : y + "px", g = ";";
                  }
                }
                h = m || null;
              }
              p = null, f ? Se.hasOwnProperty(b) || (p = A(p = b) && null != h ? p + '="' + z(h) + '"' : "") : p = _(b, h), p && (d += " " + p);
            }
          }
          u || c && (d += ' data-reactroot=""');
          var b = d;
          l = "", ue.hasOwnProperty(a) ? b += "/>" : (b += ">", l = "</" + e.type + ">");
          e: {
            if (null != (u = s.dangerouslySetInnerHTML)) {
              if (null != u.__html) {
                u = u.__html;
                break e;
              }
            } else if ("string" == typeof (u = s.children) || "number" == typeof u) {
              u = z(u);
              break e;
            }
            u = null;
          }
          return null != u ? (s = [], ve.hasOwnProperty(a) && "\n" === u.charAt(0) && (b += "\n"), b += u) : s = me(s.children), e = e.type, r = null == r || "http://www.w3.org/1999/xhtml" === r ? le(e) : "http://www.w3.org/2000/svg" === r && "foreignObject" === e ? "http://www.w3.org/1999/xhtml" : r, this.stack.push({
            domNamespace: r,
            type: a,
            children: s,
            childIndex: 0,
            context: t,
            footer: l
          }), this.previousWasTextNode = !1, b;
        }, e;
      }();
      t.renderToNodeStream = function () {
        throw Error(i(207));
      }, t.renderToStaticMarkup = function (e, t) {
        e = new Ie(e, !0, t);
        try {
          return e.read(1 / 0);
        } finally {
          e.destroy();
        }
      }, t.renderToStaticNodeStream = function () {
        throw Error(i(208));
      }, t.renderToString = function (e, t) {
        e = new Ie(e, !1, t);
        try {
          return e.read(1 / 0);
        } finally {
          e.destroy();
        }
      }, t.version = "17.0.2";
    },
    51: (e, t, r) => {
      e.exports = r(634);
    },
    810: t => {
      t.exports = e;
    }
  },
  l = {};
function u(e) {
  var t = l[e];
  if (void 0 !== t) return t.exports;
  var r = l[e] = {
    exports: {}
  };
  return s[e](r, r.exports, u), r.exports;
}
u.d = (e, t) => {
  for (var r in t) u.o(t, r) && !u.o(e, r) && Object.defineProperty(e, r, {
    enumerable: !0,
    get: t[r]
  });
}, u.o = (e, t) => Object.prototype.hasOwnProperty.call(e, t), (() => {
  var e;
  if ("string" == typeof import.meta.url && (e = import.meta.url), !e) throw new Error("Automatic publicPath is not supported in this browser");
  e = e.replace(/#.*$/, "").replace(/\?.*$/, "").replace(/\/[^\/]+$/, "/"), u.p = e;
})();
var c = {};
(() => {
  u.d(c, {
    cK: () => A,
    zA: () => N,
    v$: () => j,
    VS: () => z,
    xr: () => P,
    kO: () => F,
    _: () => k,
    I8: () => L,
    y7: () => x,
    og: () => b,
    YD: () => C,
    bV: () => T,
    G6: () => V,
    WS: () => I
  });
  const e = (s = {
    jsx: () => t.jsx,
    jsxs: () => t.jsxs
  }, l = {}, u.d(l, s), l);
  var s, l;
  const d = (e => {
    var t = {};
    return u.d(t, e), t;
  })({
    useLocalization: () => r.useLocalization
  });
  var f = u(810);
  const h = (e => {
      var t = {};
      return u.d(t, e), t;
    })({
      debounce: () => n.debounce
    }),
    p = (e => {
      var t = {};
      return u.d(t, e), t;
    })({
      Level: () => o.Level,
      analyticsTracker: () => o.analyticsTracker,
      classNames: () => o.classNames,
      liveAnnounce: () => o.liveAnnounce
    }),
    m = u.p + "./styles/egds-universal-shopping-carousel.css",
    g = (e => {
      var t = {};
      return u.d(t, e), t;
    })({
      UitkSpacing: () => i.UitkSpacing
    }),
    v = (e, {
      threshold: t = 0,
      root: r = null,
      rootMargin: n = "0%",
      freezeOnceVisible: o = !1
    }) => {
      const [i, a] = (0, f.useState)(),
        s = (i === null || i === void 0 ? void 0 : i.isIntersecting) && o,
        l = ([e]) => {
          a(e);
        };
      return (0, f.useEffect)(() => {
        const o = e === null || e === void 0 ? void 0 : e.current;
        if (!window.IntersectionObserver || s || !o) return;
        const i = new IntersectionObserver(l, {
          threshold: t,
          root: r,
          rootMargin: n
        });
        return i.observe(o), () => i.disconnect();
      }, [e === null || e === void 0 ? void 0 : e.current, JSON.stringify(t), r, n, s]), i;
    },
    y = p.classNames.bind(m),
    x = t => {
      const {
          children: r,
          wrapItems: n,
          ariaHidden: o,
          ariaLabel: i,
          stretchToFill: a,
          isAutoWidth: s,
          onItemShow: l,
          onItemFullyShow: u,
          isFirst: c,
          isLast: d,
          edgeItemsPadding: h,
          isPopoverOpen: p
        } = t,
        m = f.useRef(null),
        x = v(m, {}),
        w = Boolean(x === null || x === void 0 ? void 0 : x.isIntersecting),
        b = v(m, {
          threshold: .99
        }),
        S = Boolean(b === null || b === void 0 ? void 0 : b.isIntersecting);
      f.useEffect(() => {
        l === null || l === void 0 ? void 0 : l(w);
      }, [w]), f.useEffect(() => {
        u === null || u === void 0 ? void 0 : u(S);
      }, [S]);
      let k = "egds-team-carousel-item";
      a || (k += " egds-team-carousel-item-size-auto"), s || (k += " egds-team-carousel-item-fixed-width"), p && (k += " egds-team-carousel-item-popover-sheet-open");
      const I = r,
        E = n && I ? I.props.className : "",
        C = Object.assign(Object.assign({}, (s ? !w : o) && {
          "aria-hidden": !0,
          tabIndex: -1
        }), {
          className: y(E ? `${E} ${k}` : k),
          "data-testid": "carousel-item",
          "aria-label": i,
          ref: m
        }),
        N = n ? (0, e.jsx)("div", Object.assign(Object.assign({}, C), {
          children: I
        })) : f.cloneElement(I, C);
      return h && c ? (0, e.jsx)(g.UitkSpacing, {
        padding: {
          inlinestart: h
        },
        children: N
      }) : h && d ? (0, e.jsx)(g.UitkSpacing, {
        padding: {
          inlineend: h
        },
        children: N
      }) : N;
    };
  x.displayName = "EGDSTeamCarouselItem", x.defaultProps = {
    wrapItems: !0
  };
  const w = p.classNames.bind(m),
    b = t => {
      const {
          children: r,
          l10n: n,
          size: o,
          currentIndex: i,
          itemCount: a,
          itemsVisible: s,
          carouselListRef: l,
          onItemShow: u,
          currentItemsVisibleAuto: c,
          onScrollEnd: d,
          isPopoverOpenList: h
        } = t,
        p = __rest(t, ["children", "l10n", "size", "currentIndex", "itemCount", "itemsVisible", "carouselListRef", "onItemShow", "currentItemsVisibleAuto", "onScrollEnd", "isPopoverOpenList"]),
        m = "auto" === s[o],
        g = c !== null && c !== void 0 ? c : s[o],
        v = i,
        y = i + g;
      return (0, e.jsx)("div", {
        className: w("egds-team-carousel-item-container"),
        ref: l,
        "data-testid": "carousel-list",
        children: f.Children.map(r, (t, o) => {
          var _a;
          const i = o < v || o >= y,
            s = t,
            l = (_a = s === null || s === void 0 ? void 0 : s.key) === null || _a === void 0 ? void 0 : _a.toString(),
            c = n === null || n === void 0 ? void 0 : n.formatText("carousel.indexAndTotal", o + 1, a),
            g = 0 === o,
            w = o === f.Children.count(r) - 1;
          return (0, e.jsx)(x, Object.assign(Object.assign({
            ariaHidden: i,
            ariaLabel: l || c,
            isAutoWidth: m,
            onItemShow: e => {
              u === null || u === void 0 ? void 0 : u(e, o);
            },
            onItemFullyShow: e => {
              w && e && (d === null || d === void 0 ? void 0 : d());
            },
            isFirst: g,
            isLast: w,
            isPopoverOpen: h === null || h === void 0 ? void 0 : h[o]
          }, p), {
            children: t
          }), o);
        })
      });
    };
  b.displayName = "EGDSTeamCarouselItemList";
  const S = (e => {
      var t = {};
      return u.d(t, e), t;
    })({
      UitkPagingNextButton: () => a.UitkPagingNextButton,
      UitkPagingPrevButton: () => a.UitkPagingPrevButton
    }),
    k = new Map([["sm", "sm"], ["md", "md"], ["lg", "lg"], ["xl", "xl"]]),
    I = new Map([["h1", "h1"], ["h2", "h2"], ["h3", "h3"], ["h4", "h4"], ["h5", "h5"], ["h6", "h6"]]),
    E = p.classNames.bind(m);
  var C;
  !function (e) {
    e.clickLeft = "clickLeft", e.clickRight = "clickRight", e.scrollLeft = "scrollLeft", e.scrollRight = "scrollRight";
  }(C || (C = {}));
  const N = t => {
      const {
          analytics: r,
          buttonText: n,
          carouselHeaderLevel: o,
          carouselHeaderText: i,
          carouselHeaderVisible: a,
          carouselName: s,
          carouselRef: l,
          children: u,
          className: c,
          domRef: d,
          fullSheetVisible: m,
          hideNav: g,
          itemsVisible: v,
          itemsMaxHeight: y,
          l10n: x,
          loop: w,
          navigationIconId: S,
          onChange: k,
          onIndexChange: N,
          pageBy: L = 1,
          pagingInset: O,
          pagingOverlay: R,
          peek: F,
          shouldSnapOnScroll: A,
          startIndex: P,
          stretchToFill: D,
          wrapItems: j,
          hideNavOnScrollEnd: V
        } = t,
        [M, z] = f.useState(!1),
        [_, W] = f.useState(0),
        [$, H] = f.useState(!1),
        [q, B] = f.useState(!1),
        [U, G] = f.useState("sm"),
        [Z, K] = f.useState(!1),
        Y = f.useRef(!1),
        J = f.useRef(!1),
        X = f.useRef(!1),
        Q = f.useRef(null);
      let ee = 48,
        te = 12;
      const re = f.Children.count(u),
        ne = d !== null && d !== void 0 ? d : Q,
        oe = f.useRef(null),
        ie = f.useRef(null),
        ae = v[U],
        se = f.useRef([]),
        le = f.useRef(0),
        ue = f.useRef(0),
        ce = f.useRef(!0),
        de = () => {
          let e = ae;
          F && (e += 1);
          for (let n = 0; n < e && _ + n < f.Children.count(u); ++n) se.current[_ + n] || (se.current[_ + n] = !0, "function" == typeof t.itemViewedCallback && t.itemViewedCallback(_ + n), r && (0, p.analyticsTracker)(r, `${s}.Carousel.itemViewed.${_ + n}`, ""));
        },
        fe = f.useCallback(e => {
          r && (0, p.analyticsTracker)(r, `${s}.Carousel.${e ? C.scrollRight : C.scrollLeft}`, "");
        }, [r, s]),
        he = () => {
          if (oe.current) {
            const e = oe.current,
              {
                scrollLeft: t,
                scrollWidth: r
              } = e,
              n = e.getBoundingClientRect().width,
              o = le.current,
              i = Math.abs(t),
              a = re > 1 && i > Math.round(r - n - 5) ? 1 : 0;
            return Math.floor(i / o) + a;
          }
          return 0;
        },
        pe = e => q ? -1 * e : e,
        me = e => {
          let t;
          if (oe.current) {
            const r = oe.current,
              n = pe(r.scrollLeft),
              o = e - n,
              i = a => {
                t || (t = a);
                const {
                  done: s,
                  position: l
                } = ((e, t, r, n) => {
                  const o = e >= 350,
                    i = o ? t : r + n * (e => e < .5 ? 2 * Math.pow(e, 2) : 1 - Math.pow(-2 * e + 2, 2) / 2)(e / 350);
                  return {
                    done: o,
                    position: i
                  };
                })(a - t, e, n, o);
                r.scrollLeft = pe(l), s || window.requestAnimationFrame(i);
              };
            X.current ? (X.current = !1, r.scrollLeft = pe(e), z(!0)) : window.requestAnimationFrame(i), fe(o > 0), ue.current = e;
          }
        },
        ge = f.useCallback((0, h.debounce)(200, () => {
          if (J.current) return J.current = !1, !1;
          if (oe.current) {
            const e = oe.current,
              t = pe(e.scrollLeft);
            if (Math.abs(t - ue.current) < 1 || Y.current) return;
            t > ue.current ? ce.current = !0 : ce.current = !1;
            const r = le.current,
              n = (e => {
                const t = re - ae,
                  r = (e => !0 === ce.current ? e + 1 : e)(e);
                return r > t ? t : r;
              })(he()),
              o = r * n,
              i = o - t,
              a = e.scrollWidth - e.clientWidth;
            if (0 === i && t > 0 && t < a) return;
            A ? me(o - (F && 0 !== n ? (ee + te) / 2 : 0)) : (() => {
              if (oe.current) {
                const e = oe.current.scrollLeft,
                  t = e - ue.current > 0;
                fe(t), ue.current = e;
              }
            })(), W(n);
          }
        }), [U, q]),
        ve = f.useCallback(e => {
          e.key && (Y.current = !0, J.current = !1);
        }, [U, q]);
      f.useEffect(() => (document.body.addEventListener("keydown", ve), () => {
        document.body.removeEventListener("keydown", ve);
      }), [ve]);
      const ye = () => {
          if (oe.current) {
            const e = oe.current.getBoundingClientRect().width,
              t = F ? te + ee : 0;
            le.current = (e - (ae - 1) * te - t) / ae + te;
          }
        },
        xe = () => {
          const e = ie === null || ie === void 0 ? void 0 : ie.current;
          if (e) {
            ye();
            let t = getComputedStyle(e).getPropertyValue("--size") || "sm";
            "xl" !== t || v.xl || (t = "lg"), G(t), Z || K(!0);
          }
        },
        we = e => {
          const t = L > ae ? ae : L;
          let r = 1 === e ? _ + Number(t) : _ - Number(t);
          const n = re - ae;
          r < 0 ? r = w ? re - 1 : 0 : r === n ? r = n : r > n && (r = w ? 0 : n), Y.current = !0, W(r);
        },
        be = () => {
          we(-1);
        },
        Se = () => {
          we(1);
        },
        ke = e => {
          let t;
          Y.current = !0;
          const r = re - ae;
          t = e < 0 ? 0 : e >= r ? r : e, W(t);
        };
      return f.useEffect(() => {
        if (M && (() => {
          if (oe.current) {
            const e = oe.current.querySelectorAll('\n          .egds-team-carousel-item:not([aria-hidden="true"]) h1:not([aria-hidden="true"]),\n          .egds-team-carousel-item:not([aria-hidden="true"]) h2:not([aria-hidden="true"]),\n          .egds-team-carousel-item:not([aria-hidden="true"]) h3:not([aria-hidden="true"]),\n          .egds-team-carousel-item:not([aria-hidden="true"]) h4:not([aria-hidden="true"]),\n          .egds-team-carousel-item:not([aria-hidden="true"]) h5:not([aria-hidden="true"]),\n          .egds-team-carousel-item:not([aria-hidden="true"]) h6:not([aria-hidden="true"])\n        '),
              t = Array.from(e).map(e => e.innerText || e.textContent);
            t.length > 0 ? setTimeout(() => {
              (0, p.liveAnnounce)(x.formatText("carousel.cardChange", t.join(", ")), p.Level.POLITE);
            }, 200) : setTimeout(() => {
              (0, p.liveAnnounce)(x.formatText("gallerycarousel.imageChange", _ + 1, re, ""), p.Level.POLITE);
            }, 200);
          }
        })(), Z && de(), Y.current) {
          Y.current = !1, J.current = !0;
          const e = F && 0 !== _ ? (ee + te) / 2 / _ : 0;
          me(_ * (le.current - e));
        }
        N && N(_);
      }, [_, Z]), f.useEffect(() => {
        xe(), oe.current && (oe.current.scrollLeft = 0), P ? (X.current = !0, ke(P)) : z(!0), (() => {
          const e = ne.current;
          e && (ee = 16 * parseInt(getComputedStyle(e).getPropertyValue("--peek-width"), 10) || ee, te = 16 * parseInt(getComputedStyle(e).getPropertyValue("--item-padding"), 10) || te);
        })(), "ontouchstart" in window && H(!0), "rtl" === document.querySelector("html").getAttribute("dir") && B(!0), (0, p.liveAnnounce)(""), Z && de();
      }, [Z]), f.useEffect(() => {
        let e = window.innerWidth;
        const t = (0, h.debounce)(200, () => {
          if (e === window.innerWidth) return;
          e = window.innerWidth, xe();
          const t = he();
          W(t);
          const r = F && 0 !== t ? (ee + te) / 2 / t : 0;
          me(t * (le.current - r));
        });
        return window.addEventListener("resize", t), ye(), () => window.removeEventListener("resize", t);
      }, [U, _]), f.useEffect(() => {
        k && k(oe), (() => {
          if (oe.current) {
            const e = oe.current.querySelectorAll(".egds-team-carousel-item");
            Array.from(e).forEach(e => {
              const t = e.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
              Array.from(t).filter(e => !e.hasAttribute("aria-hidden")).forEach(t => t[e.hasAttribute("aria-hidden") ? "setAttribute" : "removeAttribute"]("tabindex", "-1"));
            });
          }
        })();
      }), f.useImperativeHandle(l, () => ({
        changeIndex: e => ke(e)
      })), (() => {
        const t = {};
        t["--carousel-item-count"] = v[U], t["--carousel-item-count-sm"] = v.sm, t["--carousel-item-count-md"] = v.md, t["--carousel-item-count-lg"] = v.lg, t["--carousel-item-count-xl"] = v.xl ? v.xl : v.lg;
        const l = E("egds-team-carousel", (!F || !(ae < re)) && "no-peek", !O && "no-inset", !$ && "no-touch", y && "items-max-height", c, {
            [U]: !!U && "undefined" != typeof window
          }),
          d = {
            analytics: r,
            buttonText: n,
            carouselName: s,
            currentIndex: _,
            itemCount: re,
            itemsVisible: v,
            fullSheetVisible: m,
            loop: w,
            navigationIconId: S,
            onNextCb: Se,
            onPrevCb: be,
            pagingOverlay: R,
            size: U,
            isRtl: q,
            hideNavOnScrollEnd: V
          },
          f = o && I.get(o) || I.get("h3");
        return (0, e.jsxs)("div", {
          className: l,
          ref: ne,
          "data-testid": "carousel-wrapper",
          children: [i && (0, e.jsx)(f, {
            className: E({
              "is-visually-hidden": !a
            }),
            children: i
          }), (0, e.jsx)("div", {
            className: E("egds-team-carousel-container"),
            "aria-label": i,
            ref: oe,
            onScroll: ge,
            "data-testid": "carousel-container",
            style: t,
            tabIndex: 0,
            children: (0, e.jsx)(b, {
              itemsVisible: v,
              size: U,
              currentIndex: _,
              l10n: x,
              peek: F,
              wrapItems: j,
              itemCount: re,
              stretchToFill: D,
              carouselListRef: ie,
              children: u
            })
          }), !g && (0, e.jsx)(T, Object.assign({}, d))]
        });
      })();
    },
    L = t => {
      const r = (0, d.useLocalization)();
      return (0, e.jsx)(N, Object.assign({
        l10n: r
      }, t));
    };
  L.displayName = "EGDSTeamCarouselFixedWidth", L.defaultProps = {
    hideNav: !1,
    itemsMaxHeight: !1,
    navigationIconId: {
      next: "next-button",
      prev: "prev-button"
    },
    pagingInset: !1,
    pagingOverlay: !1,
    shouldSnapOnScroll: !1,
    startIndex: 0,
    stretchToFill: !0,
    wrapItems: !0,
    hideNavOnScrollEnd: !1
  };
  const O = p.classNames.bind(m),
    T = t => {
      const {
          analytics: r,
          buttonText: n,
          carouselName: o,
          currentIndex: i,
          currentLastIndex: a,
          itemCount: s,
          itemsVisible: l,
          fullSheetVisible: u,
          loop: c,
          navigationIconId: d,
          onNextCb: p,
          onPrevCb: m,
          pagingOverlay: g,
          size: v,
          isRtl: y,
          hideNavOnScrollEnd: x,
          currentItemsVisibleAuto: w,
          isVisible: b
        } = t,
        k = w !== null && w !== void 0 ? w : l[v],
        I = f.useRef(null),
        E = f.useRef(null),
        N = "undefined" != typeof window && "ontouchstart" in window ? 50 : 0,
        L = r && Object.assign({
          localAnalyticsId: `${o}.Carousel.${C.clickLeft}`
        }, r),
        T = r && Object.assign({
          localAnalyticsId: `${o}.Carousel.${C.clickRight}`
        }, r),
        R = e => {
          (e === null || e === void 0 ? void 0 : e.current) && e.current.focus();
        },
        F = (0, h.debounce)(N, () => {
          m === null || m === void 0 ? void 0 : m(), k > 0 && 1 === i && R(E);
        }),
        A = (0, h.debounce)(N, () => {
          p === null || p === void 0 ? void 0 : p(), k > 0 && i === s - k - 1 && R(I);
        }),
        P = f.useCallback(e => {
          y ? "ArrowLeft" === e.key ? A() : "ArrowRight" === e.key && F() : "ArrowLeft" === e.key ? F() : "ArrowRight" === e.key && A();
        }, [y, A, F]);
      if (f.useEffect(() => {
        if (u) return document.body.addEventListener("keydown", P), () => {
          document.body.removeEventListener("keydown", P);
        };
      }, [u, P]), s <= k) return null;
      const D = !c && 0 === i,
        j = !c && i === s - k || a === s - 1,
        V = !1 === b || x && D,
        M = !1 === b || x && j,
        z = O("egds-team-carousel-button-paging", "egds-team-carousel-button-prev", V && "egds-team-carousel-button-hidden"),
        _ = O("egds-team-carousel-button-paging", "egds-team-carousel-button-next", M && "egds-team-carousel-button-hidden");
      return (0, e.jsxs)("div", {
        className: O("egds-team-carousel-controls"),
        children: [(0, e.jsx)(S.UitkPagingPrevButton, {
          analytics: L,
          className: z,
          iconId: d === null || d === void 0 ? void 0 : d.prev,
          iconTitle: n.prevButton,
          onClick: F,
          domRef: E,
          "data-testid": "carousel-nav-prev",
          "aria-disabled": D || V,
          "aria-label": n.prevButton,
          tabIndex: D || V ? -1 : 0,
          pagingOverlay: g
        }), (0, e.jsx)(S.UitkPagingNextButton, {
          analytics: T,
          className: _,
          iconId: d === null || d === void 0 ? void 0 : d.next,
          iconTitle: n.nextButton,
          onClick: A,
          domRef: I,
          "data-testid": "carousel-nav-next",
          "aria-disabled": j || M,
          "aria-label": n.nextButton,
          tabIndex: j || M ? -1 : 0,
          pagingOverlay: g
        })]
      });
    };
  T.displayName = "EGDSTeamCarouselNav";
  const R = p.classNames.bind(m);
  var F;
  !function (e) {
    e.clickLeft = "clickLeft", e.clickRight = "clickRight", e.scrollLeft = "scrollLeft", e.scrollRight = "scrollRight";
  }(F || (F = {}));
  const A = t => {
      var _a;
      const {
          buttonText: r,
          carouselHeaderLevel: n,
          carouselHeaderText: o,
          carouselHeaderVisible: i,
          carouselName: a,
          children: s,
          className: l,
          domRef: u,
          fullSheetVisible: c,
          hideNav: d,
          itemsVisible: m,
          itemsMaxHeight: g,
          l10n: v,
          navigationIconId: y,
          onChange: x,
          onIndexChange: w,
          pagingInset: S,
          pagingOverlay: k,
          startIndex: E,
          stretchToFill: C,
          wrapItems: N,
          hideNavOnScrollEnd: L,
          itemViewedCallback: O,
          onNextButtonClick: A,
          onPrevButtonClick: P,
          onScrollEnd: D,
          edgeItemsPadding: j,
          isPopoverOpenList: V
        } = t,
        [M, z] = f.useState(!1),
        [_, W] = f.useState(!1),
        [$, H] = f.useState(!1),
        [q, B] = f.useState("sm"),
        [U, G] = f.useState(!1),
        [Z, K] = f.useState([]),
        [Y, J] = f.useState(0),
        [X, Q] = f.useState(!1),
        [ee, te] = f.useState(0),
        re = f.useRef(!0),
        ne = f.useRef(!1),
        oe = f.useRef(!1),
        ie = f.useRef(!1),
        ae = f.useRef(null);
      let se = 48,
        le = 8;
      const ue = f.Children.count(s),
        ce = u !== null && u !== void 0 ? u : ae,
        de = f.useRef(null),
        fe = f.useRef(null),
        he = Z.reduce((e, t) => t ? e + 1 : e, 0),
        pe = (_a = V === null || V === void 0 ? void 0 : V.some(Boolean)) !== null && _a !== void 0 ? _a : !1,
        me = f.useRef([]),
        ge = f.useRef(0),
        ve = f.useRef(!0),
        ye = f.useRef(0),
        xe = f.useRef(0),
        we = f.useRef(0),
        be = f.useRef(0),
        Se = f.useRef(!1),
        ke = (e, t) => {
          const r = [...Z];
          r[t] = e, re.current && (ye.current = $ ? r.lastIndexOf(!0) : r.indexOf(!0), xe.current = $ ? r.indexOf(!0) : r.lastIndexOf(!0)), K(r), e && !me.current[t] && (me.current[t] = !0, O === null || O === void 0 ? void 0 : O(t));
        },
        Ie = () => {
          Se.current || (clearTimeout(be.current), Q(!0), be.current = window.setTimeout(() => Q(!1), 2e3));
        },
        Ee = e => $ ? -1 * e : e,
        Ce = f.useCallback(e => {
          e.key && (ne.current = !0, oe.current = !1);
        }, []);
      f.useEffect(() => (document.body.addEventListener("keydown", Ce), () => {
        document.body.removeEventListener("keydown", Ce);
      }), [Ce]);
      const Ne = () => {
          const e = fe === null || fe === void 0 ? void 0 : fe.current;
          if (e) {
            let t = getComputedStyle(e).getPropertyValue("--size") || "sm";
            "xl" !== t || m.xl || (t = "lg"), B(t), U || G(!0);
          }
        },
        Le = (e, t) => {
          if (!de.current || !fe.current) return;
          const r = [...fe.current.children],
            {
              left: n,
              right: o
            } = r[e].getBoundingClientRect(),
            {
              width: i
            } = de.current.getBoundingClientRect(),
            {
              left: a,
              right: s
            } = r[0].getBoundingClientRect();
          let l = 0;
          $ ? e === ue - 1 ? l = s - n - i : t === F.scrollRight && e > 0 ? l = Math.ceil(s - (n + o) / 2) : t === F.scrollLeft && (l = Math.floor(s - i - (n + o) / 2)) : e === ue - 1 ? l = o - a - i : t === F.scrollRight ? l = Math.ceil((n + o) / 2 - i - a) : t === F.scrollLeft && e > 0 && (l = Math.floor((n + o) / 2 - a)), ne.current = !0, (e => {
            if (!de.current) return;
            let t;
            re.current = !1;
            const r = de.current,
              n = Ee(r.scrollLeft),
              o = e - n,
              i = a => {
                t || (t = a);
                const {
                  done: s,
                  position: l
                } = ((e, t, r, n) => {
                  const o = e >= 350,
                    i = o ? t : r + n * (e => e < .5 ? 2 * Math.pow(e, 2) : 1 - Math.pow(-2 * e + 2, 2) / 2)(e / 350);
                  return {
                    done: o,
                    position: i
                  };
                })(a - t, e, n, o);
                r.scrollLeft = Ee(l), s ? J(a) : we.current = window.requestAnimationFrame(i);
              };
            ie.current ? (ie.current = !1, r.scrollLeft = Ee(e), z(!0)) : (window.cancelAnimationFrame(we.current), we.current = window.requestAnimationFrame(i));
          })(l);
        };
      f.useEffect(() => {
        re.current = !0, ke(!0, $ ? ve.current ? ye.current : xe.current : ve.current ? xe.current : ye.current);
      }, [Y]), f.useEffect(() => {
        M && (() => {
          if (de.current) {
            const e = de.current.querySelectorAll('\n          .egds-team-carousel-item:not([aria-hidden="true"]) h1:not([aria-hidden="true"]),\n          .egds-team-carousel-item:not([aria-hidden="true"]) h2:not([aria-hidden="true"]),\n          .egds-team-carousel-item:not([aria-hidden="true"]) h3:not([aria-hidden="true"]),\n          .egds-team-carousel-item:not([aria-hidden="true"]) h4:not([aria-hidden="true"]),\n          .egds-team-carousel-item:not([aria-hidden="true"]) h5:not([aria-hidden="true"]),\n          .egds-team-carousel-item:not([aria-hidden="true"]) h6:not([aria-hidden="true"])\n        '),
              t = Array.from(e).map(e => e.innerText || e.textContent);
            t.length > 0 ? setTimeout(() => {
              (0, p.liveAnnounce)(v.formatText("carousel.cardChange", t.join(", ")), p.Level.POLITE);
            }, 200) : setTimeout(() => {
              (0, p.liveAnnounce)(v.formatText("gallerycarousel.imageChange", ye.current + 1, ue, ""), p.Level.POLITE);
            }, 200);
          }
        })(), w === null || w === void 0 ? void 0 : w(ye.current);
      }, [U]), f.useEffect(() => {
        Ne(), de.current && (de.current.scrollLeft = 0), E ? ie.current = !0 : z(!0), (() => {
          const e = ce.current;
          e && (se = 16 * parseInt(getComputedStyle(e).getPropertyValue("--peek-width"), 10) || se, le = 16 * parseInt(getComputedStyle(e).getPropertyValue("--item-padding"), 10) || le);
        })(), "ontouchstart" in window && W(!0), "rtl" === document.querySelector("html").getAttribute("dir") && H(!0), (0, p.liveAnnounce)("");
      }, [U]), f.useEffect(() => {
        let e = window.innerWidth;
        const t = (0, h.debounce)(200, () => {
          e !== window.innerWidth && (e = window.innerWidth, Ne());
        });
        return window.addEventListener("resize", t), () => window.removeEventListener("resize", t);
      }, [q]), f.useEffect(() => {
        x === null || x === void 0 ? void 0 : x(de), (() => {
          if (de.current) {
            const e = de.current.querySelectorAll(".egds-team-carousel-item");
            Array.from(e).forEach(e => {
              const t = e.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
              Array.from(t).filter(e => !e.hasAttribute("aria-hidden")).forEach(t => t[e.hasAttribute("aria-hidden") ? "setAttribute" : "removeAttribute"]("tabindex", "-1"));
            });
          }
        })();
      }), f.useEffect(() => {
        te(pe ? -ge.current : 0);
      }, [pe]);
      const Oe = {
        marginInlineStart: ee
      };
      Oe["--carousel-item-count"] = m[q], Oe["--carousel-item-count-sm"] = m.sm, Oe["--carousel-item-count-md"] = m.md, Oe["--carousel-item-count-lg"] = m.lg, Oe["--carousel-item-count-xl"] = m.xl ? m.xl : m.lg;
      const Te = R("egds-team-carousel", "no-peek", !S && "no-inset", !_ && "no-touch", g && "items-max-height", l, {
          [q]: !!q && "undefined" != typeof window
        }, pe && "popover-sheet-open"),
        Re = {
          buttonText: r,
          carouselName: a,
          currentIndex: $ ? xe.current : ye.current,
          currentLastIndex: $ ? ye.current : xe.current,
          itemCount: ue,
          itemsVisible: m,
          fullSheetVisible: c,
          navigationIconId: y,
          onNextCb: () => {
            A === null || A === void 0 ? void 0 : A(), $ ? (ye.current = Math.min(ye.current + 1, ue - 1), Le(ye.current, F.scrollLeft)) : (xe.current = Math.min(xe.current + 1, ue - 1), Le(xe.current, F.scrollRight));
          },
          onPrevCb: () => {
            P === null || P === void 0 ? void 0 : P(), $ ? (xe.current = Math.max(xe.current - 1, 0), Le(xe.current, F.scrollRight)) : (ye.current = Math.max(ye.current - 1, 0), Le(ye.current, F.scrollLeft));
          },
          pagingOverlay: k,
          size: q,
          isRtl: $,
          hideNavOnScrollEnd: L,
          currentItemsVisibleAuto: he,
          isVisible: X
        },
        Fe = n && I.get(n) || I.get("h3");
      return (0, e.jsxs)("div", {
        className: Te,
        ref: ce,
        "data-testid": "carousel-wrapper",
        children: [o && (0, e.jsx)(Fe, {
          className: R({
            "is-visually-hidden": !i
          }),
          children: o
        }), (0, e.jsx)("div", {
          className: R(pe ? "" : "egds-team-carousel-container"),
          "aria-label": o,
          ref: de,
          onScroll: () => {
            if (!de.current) return;
            const e = Ee(de.current.scrollLeft);
            e > ge.current ? ve.current = !0 : ve.current = !1, ge.current = e, Ie();
          },
          "data-testid": "carousel-container",
          style: Oe,
          tabIndex: 0,
          onClick: Ie,
          onKeyDown: Ie,
          onMouseEnter: () => {
            "sm" !== q && (Se.current = !0, clearTimeout(be.current), Q(!0));
          },
          onMouseLeave: () => {
            "sm" !== q && (Se.current = !1, be.current = window.setTimeout(() => Q(!1), 2e3));
          },
          children: (0, e.jsx)(b, {
            itemsVisible: m,
            size: q,
            currentIndex: $ ? xe.current : ye.current,
            l10n: v,
            wrapItems: N,
            itemCount: ue,
            stretchToFill: C,
            carouselListRef: fe,
            onItemShow: ke,
            currentItemsVisibleAuto: he,
            onScrollEnd: D,
            edgeItemsPadding: j,
            isPopoverOpenList: V,
            children: s
          })
        }), !d && (0, e.jsx)(T, Object.assign({}, Re))]
      });
    },
    P = t => {
      const r = (0, d.useLocalization)();
      return (0, e.jsx)(A, Object.assign({
        l10n: r
      }, t));
    };
  P.displayName = "EGDSTeamCarouselAutoWidth", P.defaultProps = {
    hideNav: !1,
    itemsMaxHeight: !1,
    navigationIconId: {
      next: "next-button",
      prev: "prev-button"
    },
    pagingInset: !1,
    pagingOverlay: !1,
    startIndex: 0,
    stretchToFill: !0,
    wrapItems: !0,
    hideNavOnScrollEnd: !1
  };
  const D = p.classNames.bind(m),
    j = t => {
      const {
          activeIndex: r,
          changeIndex: n,
          inset: o,
          itemCount: i,
          l10n: a
        } = t,
        s = f.createRef(),
        {
          formatText: l
        } = a,
        u = "egds-team-carousel-pagination-dots",
        c = (e = r) => e <= Math.floor(2.5),
        d = (e = r) => e >= i - 1 - Math.floor(2.5),
        h = e => {
          let t;
          return t = c(e) ? 0 : d(e) ? i - 5 : r - Math.floor(2.5), t;
        },
        [p, m] = f.useState(h);
      f.useEffect(() => {
        m(h());
      }, [r]), f.useEffect(() => {
        const e = 12 * p;
        s && s.current && (s.current.scrollLeft = e);
      }, [s, p]);
      const g = e => {
        var _a;
        const t = Number((_a = e.currentTarget) === null || _a === void 0 ? void 0 : _a.value);
        h(t), n && n(t);
      };
      return (0, e.jsx)("div", {
        ref: s,
        className: D(`${u}-container`),
        children: (() => {
          const t = [];
          for (let n = 0; n < i; n++) {
            const a = n === p + 5 - 1,
              s = r === n,
              f = n === p && !c() || a && !d(),
              h = `${u}-icon`,
              m = D(h, {
                [`${h}-focus`]: s,
                [`${h}-truncate`]: f,
                [`${h}-default`]: !f && !s,
                [`${h}-inset`]: o,
                [`${h}-offset`]: !o
              }),
              v = n < p || n >= p + 5;
            t.push((0, e.jsx)("button", {
              "aria-label": l("carousel.indexAndTotal", n + 1, i),
              "aria-hidden": v,
              "aria-current": n === r && "location",
              tabIndex: v ? -1 : 0,
              type: "button",
              className: D(`${u}-button`),
              onClick: e => g(e),
              value: n,
              children: (0, e.jsx)("div", {
                className: D(m),
                "aria-hidden": "true"
              })
            }, n));
          }
          return t;
        })()
      });
    },
    V = t => {
      const r = (0, d.useLocalization)();
      return (0, e.jsx)(j, Object.assign({
        l10n: r
      }, t));
    };
  V.displayName = "EGDSTeamCarouselPaginationDots";
  var M = u(51);
  const z = t => {
    const {
        itemsVisible: r,
        children: n
      } = t,
      o = __rest(t, ["itemsVisible", "children"]),
      i = f.Children.map(n, e => (e => "" === M.renderToStaticMarkup(e))(e) ? null : e);
    return "auto" === r.sm && "auto" === r.md && "auto" === r.lg && "auto" === r.xl ? (0, e.jsx)(P, Object.assign(Object.assign({}, o), {
      itemsVisible: r,
      children: i
    })) : "auto" === r.sm || "auto" === r.md || "auto" === r.lg || "auto" === r.xl ? null : (0, e.jsx)(L, Object.assign(Object.assign({}, o), {
      itemsVisible: r,
      children: i
    }));
  };
  z.displayName = "EGDSTeamCarousel", z.defaultProps = {
    hideNav: !1,
    itemsMaxHeight: !1,
    navigationIconId: {
      next: "next-button",
      prev: "prev-button"
    },
    pagingInset: !1,
    pagingOverlay: !1,
    shouldSnapOnScroll: !1,
    startIndex: 0,
    stretchToFill: !0,
    wrapItems: !0,
    hideNavOnScrollEnd: !1
  };
})();
var d = c.cK,
  f = c.zA,
  h = c.v$,
  p = c.VS,
  m = c.xr,
  g = c.kO,
  v = c._,
  y = c.I8,
  x = c.y7,
  w = c.og,
  b = c.YD,
  S = c.bV,
  k = c.G6,
  I = c.WS;
export { d as CarouselAutoWidth, f as CarouselFixedWidth, h as CarouselPaginationDots, p as EGDSTeamCarousel, m as EGDSTeamCarouselAutoWidth, g as EGDSTeamCarouselAutoWidthEvents, v as EGDSTeamCarouselBreakPointSizes, y as EGDSTeamCarouselFixedWidth, x as EGDSTeamCarouselItem, w as EGDSTeamCarouselItemList, b as EGDSTeamCarouselLocalAnalyticsIdType, S as EGDSTeamCarouselNav, k as EGDSTeamCarouselPaginationDots, I as EGDSTeamHeadingTags };